import {Component, ChangeDetectionStrategy, Input, ViewChild} from '@angular/core';
import { MdlTextFieldComponent } from '@angular-mdl/core';
import { FormControl } from '@angular/forms';
@Component({
    selector: 'search-bar',
    template: require('./search-bar.component.html'),
    styles: [require('./search-bar.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent {

    @ViewChild('searchText')
    public selectFilterComponent: MdlTextFieldComponent;

    @Input()
    public control: FormControl;

    @Input()
    public searchType = 'basic';

    @Input()
    public label: string;

    public resetFilter() {
        this.control.reset();
        this.selectFilterComponent.setFocus();
    }
}